import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-673bc44a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h5" }, " Click the button below to see if you can win some $FIRE tokens. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-h5 btn-text" }, " Play Lottery ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " The odds of winning are 10:1 and the clears every 12hrs. This is just a fun side reason to be here, as you may have noticed, you earn $FIRE just by using the site as normal. ", -1))
const _hoisted_6 = { class: "text-h6 flex justify-center q-pa-lg" }
const _hoisted_7 = {
  href: "https://solscan.io/account/F1RELQfqm789aGdLsdXRusCnrVEhqWGg3rrRDQsFXvR8",
  target: "_blank"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" F1RELQfqm789aGdLsdXRusCnrVEhqWGg3rrRDQsFXvR8 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Look at $FIRE on Solscan")

import { watchEffect, ref, onMounted } from 'vue'
import { server, requestOptions } from '@/utils/helpers'
import { useWallet } from 'solana-wallets-vue'
import { tokenLottery } from '@/utils/tokens';
import useQuasar from 'quasar/src/composables/use-quasar.js';;


export default /*#__PURE__*/_defineComponent({
  __name: 'LotteryButton',
  setup(__props) {

const wallet = useWallet()
const eligibility = ref(true)
const eligibilityChecked = ref(false);
const $q = useQuasar()
const whyNoPlay = ref('');

onMounted(() => resetCheck())

watchEffect(() => {
    if (!eligibilityChecked.value) {
        checkLotteryEligibility();
    }
})

// async function handleListClear() {
//     await fetch(`${server()}token/clearLottery`, requestOptions())
//     return
// }
function handleConnectWarning() {
    return $q.notify({
        type: 'warning',
        icon: 'warning',
        message: 'Not Eligible to Play',
        caption: 'Is your wallet connected?',
        position: 'center'
    })
}

function resetCheck() {
    console.log("resetCheck")
    eligibilityChecked.value = false;
    setTimeout(resetCheck, 1000 * 60 * 30)
    return
}

async function checkLotteryEligibility() {
    console.log('Checking Eligibility...')
    if (!wallet.publicKey.value) {
        return
    }
    const data = { walletString: wallet.publicKey.value.toBase58() }
    // console.log({ data })
    const response = await fetch(`${server()}token/eligibility/lottery`, requestOptions(data))
    const eligible = await response.json()
    whyNoPlay.value = eligible.message
    eligibility.value = response.status === 200
    return eligibilityChecked.value = true

}

async function handleTokenLottery() {
    let pubkey: string | null = null
    if (wallet.publicKey.value) {
        pubkey = wallet.publicKey.value.toBase58()
    }
    console.log(pubkey)
    try {

        const result = await tokenLottery(pubkey!);
        $q.notify({
            // type: 'success',
            icon: 'grade',
            color: 'secondary',
            message: 'Lottery Results',
            caption: result,
            position: 'top',
            timeout: 10000
        })

        return checkLotteryEligibility()
    } catch (err) {
        console.log(err)
        handleConnectWarning()
        return
    }
}


return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    dark: "",
    class: "card"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "heading" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (!!_unref(wallet).publicKey.value && eligibility.value)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 0,
            class: "section"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_avatar, { class: "white-shadow logo-avatar" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_btn, {
                class: "lottery--btn flex justify-evenly",
                dark: "",
                onClick: _cache[0] || (_cache[0] = () => handleTokenLottery())
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_q_avatar, { class: "white-shadow logo-avatar" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_5
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(whyNoPlay.value), 1)
            ]),
            _: 1
          })),
      _createVNode(_component_q_card_section, { class: "text-center link" }, {
        default: _withCtx(() => [
          _createElementVNode("a", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})